import React, { useEffect, useRef, useCallback, useMemo, useImperativeHandle } from 'react';
import './index.scss';
import { apiHolder as api, inWindow, apis, locationHelper } from 'api';
import MailCardList from '../../common/components/vlist/MailCardList/MailCardList';
import MailCard from '../../common/components/vlistCards/MailCard/MailCard';
import { CardOperRedFlag, CardOperFollowUp } from '../../common/components/vlistCards/MailCard/defaultComs';
import ListLoading from '../../common/components/ListLoading/index';
import HotKeys from '../../common/components/HotKeys/HotKeysMult';
import { ModuleHotKeyEvent } from '../ListHotKeys/moduleHotKey';
import { folderIdIsContact, getMailKey, isMainAccount, scanMailsSetTimeGradients, systemIsWindow, folderIdIsAllFolder, parseFidFromAllFid } from '../../util';
import useState2RM from '../../hooks/useState2ReduxMock';
import { LIST_MODEL, TASK_MAIL_STATUS } from '../../common/constant';
import { getCardHeight } from '@web-mail/utils/mailCardUtil';
import { useAppSelector } from '@web-common/state/createStore';
import { createSelector } from '@reduxjs/toolkit';
import { isMailDiff } from '@web-mail/utils/mailCompare';
import { renderContacts } from '@web-mail/common/components/vlistCards/MailCard/defaultComs';
import { FLOLDER } from '@web-mail/common/constant';
import lodash from 'lodash';
import useMailListHotkeys from './useMailListHotkeys';
const eventApi = api.api.getEventApi();
const systemApi = api.api.getSystemApi();
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
import { getIn18Text } from 'api';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
const VoidCom = () => React.createElement(React.Fragment, null);
const defaultList = [];
const defaultCallback = () => { };
const MailList = (props, ref) => {
    const { onContextMenu, onDragStart, onDragEnd, onDoubleClick, onActiveInWindow, hkDisabled, onSelect, onUnSelect, beforeSelected, onActive, customerLabelAfter = null, data, loadMoreRows, rowCount, listHeight, listWidth, scrollTop, listLoading, notice, tagName, isSearching, activeId = defaultList, refreshPage, topExtraData = defaultList, showGroupDecorate = true, checkable = true, showCheckbox = true, total, batchSize, threshold, scrollingResetTimeInterval, overscanRowCount, pullRefreshLoadingHeight, loadMoreLoadingHeight, rowHeight, onScroll, noMoreRender, pullRefreshRender, loadMoreLoadingRender, noRowsRenderer, onPullRefresh, onLoadMore, loadMoreLoadingFailRender, listFouceRender, onDelete, mailCardSummary, useRealList = false, listModel = LIST_MODEL.INIT, onListModelChange, selected, selectedKeys, forceShowAttachment = false, realListPager = null, realListClassName = '', isRefresh, onContentInsufficientHeight, MailMergeConfig, from, onGroupCollapse, groupCollapse, showSuborbinateFrom = false, isAIMailTab = false, } = props;
    const isCorpMail = useMemo(() => {
        return systemApi.getIsCorpMailMode();
    }, []);
    const [showAvator] = useState2RM('configMailListShowAvator', 'doUpdateConfigMailListShowAvator');
    const scrollTopRef = useRef(0);
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const ListHotKeys = useMemo(() => HotKeys(MailCardList, ModuleHotKeyEvent), []);
    const listCanDrag = useCallback(() => {
        if (isAIMailTab) {
            return false;
        }
        if (isSearching) {
            return false;
        }
        if (folderIdIsAllFolder(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id)) {
            return false;
        }
        const fid = selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id;
        const staticForbidRule = [FLOLDER.DRAFT, FLOLDER.WAITINGISSUE, FLOLDER.READYISSUE];
        const res = !staticForbidRule.some(item => item === fid);
        return res;
    }, [isSearching, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, isAIMailTab]);
    const mailCanDrag = useCallback(mail => {
        if (mail) {
            const { taskInfo } = mail;
            return (taskInfo === null || taskInfo === void 0 ? void 0 : taskInfo.status) !== TASK_MAIL_STATUS.PROCESSING;
        }
        return true;
    }, []);
    const handleReadFlagClick = useCallback((data) => {
        const { mark, threadMessageIds, id } = data.entry || {};
        eventApi.sendSysEvent({
            eventName: 'mailStatesChanged',
            eventData: {
                mark: mark === 'none',
                id: isCorpMail && threadMessageIds && threadMessageIds.length ? threadMessageIds : id,
                type: 'redFlag',
            },
            _account: data._account,
            eventStrData: mark === 'none' ? 'mark' : 'unmark',
        });
    }, []);
    const CardOperRedFlagWrap = useCallback((_props) => (React.createElement("span", { onClick: e => {
            e.stopPropagation();
            handleReadFlagClick(_props.data);
        } },
        React.createElement(CardOperRedFlag, Object.assign({}, _props)))), [handleReadFlagClick]);
    const handleFollowUpClick = useCallback((data) => {
        const { _account } = data;
        const { mark, id, isFollowUp } = data.entry || {};
        eventApi.sendSysEvent({
            eventName: 'mailMenuOper',
            eventData: {
                ids: [id],
                accounts: [_account],
                mark: !isFollowUp,
                track: true,
            },
            eventStrData: 'markProcessFollow',
            _account,
        });
    }, []);
    const CardOperFollowUpWrap = useCreateCallbackForEvent((_props) => (React.createElement("span", { style: { marginRight: 3 }, onClick: e => {
            e.stopPropagation();
            handleFollowUpClick(_props.data);
        } },
        React.createElement(CardOperFollowUp, Object.assign({}, _props)))));
    const CustomMailCard = useCallback((_props) => {
        var _a, _b, _c, _d, _e, _f;
        const key = selectedKeys && (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id);
        const showReadFlag = !(key === FLOLDER.DELETED || key === FLOLDER.SPAM);
        const showFollowUp = (process.env.BUILD_ISEDM || navigateVersion) && [FLOLDER.CUSTOMER_UNFOLLOW, FLOLDER.UNFOLLOW].some(id => id == parseFidFromAllFid(key));
        const isTask = ((_a = _props === null || _props === void 0 ? void 0 : _props.data) === null || _a === void 0 ? void 0 : _a.taskId) != null;
        const isTpMail = (_b = _props === null || _props === void 0 ? void 0 : _props.data) === null || _b === void 0 ? void 0 : _b.isTpMail;
        const isShowCheckBox = typeof showCheckbox == 'function' ? showCheckbox(_props === null || _props === void 0 ? void 0 : _props.data) : showCheckbox;
        const excludeKeyMap = useCallback((state) => state.mailReducer.mailExcludeKeyMap, []);
        const mailStore = useCallback((state) => state.mailReducer.mailEntities, []);
        const mailSelector = useMemo(() => createSelector([mailStore, excludeKeyMap], (store, excludeMap) => {
            var _a, _b;
            const id = (_b = (_a = _props === null || _props === void 0 ? void 0 : _props.data) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.id;
            const mail = id ? store[id] : null;
            if (MailMergeConfig && MailMergeConfig.key && MailMergeConfig.exclude && MailMergeConfig.exclude.length) {
                const res = mail
                    ? Object.assign(Object.assign({}, mail), { entry: Object.assign({}, mail.entry) }) : {};
                MailMergeConfig.exclude.forEach(path => {
                    lodash.set(res, path, lodash.get(excludeMap, [MailMergeConfig.key, id].join('.') + path));
                });
                return res;
            }
            else {
                return mail;
            }
        }), [(_d = (_c = _props === null || _props === void 0 ? void 0 : _props.data) === null || _c === void 0 ? void 0 : _c.entry) === null || _d === void 0 ? void 0 : _d.id]);
        const defaultSelecter = useCallback(state => {
            var _a, _b, _c, _d;
            if ((_a = state === null || state === void 0 ? void 0 : state.mailReducer) === null || _a === void 0 ? void 0 : _a.mailEntities) {
                return (_b = state === null || state === void 0 ? void 0 : state.mailReducer) === null || _b === void 0 ? void 0 : _b.mailEntities[(_d = (_c = _props === null || _props === void 0 ? void 0 : _props.data) === null || _c === void 0 ? void 0 : _c.entry) === null || _d === void 0 ? void 0 : _d.id];
            }
        }, [(_f = (_e = _props === null || _props === void 0 ? void 0 : _props.data) === null || _e === void 0 ? void 0 : _e.entry) === null || _f === void 0 ? void 0 : _f.id]);
        const data = useAppSelector(isSearching ? mailSelector : defaultSelecter, (old, newValue) => {
            return !isMailDiff(old, newValue);
        });
        return (React.createElement(MailCard, Object.assign({}, _props, { forceShowAttachment: forceShowAttachment, showSuborbinateFrom: showSuborbinateFrom, data: data || (_props === null || _props === void 0 ? void 0 : _props.data), customerLabelAfter: customerLabelAfter, summary: mailCardSummary, summaryExtra: showReadFlag && !isTask && !isTpMail ? CardOperRedFlagWrap : isTpMail ? null : VoidCom, summaryFollowUp: showFollowUp && !isTask && !isTpMail ? CardOperFollowUpWrap : isTpMail ? null : VoidCom, hideTag: tagName, isMultiple: listModel == LIST_MODEL.MULTIPLE, showCheckbox: isShowCheckBox, hoverCheckbox: systemApi.inEdm() && showAvator, showAvator: showAvator, from: from })));
    }, [selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, tagName, listModel, mailCardSummary, showAvator, showCheckbox, CardOperRedFlagWrap, isSearching, from, navigateVersion, showSuborbinateFrom]);
    const defaultOnMailDrag = useCallback((event, item) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData('accountId', `${item === null || item === void 0 ? void 0 : item._account}`);
        event.dataTransfer.setData('isThread', `${item === null || item === void 0 ? void 0 : item.isThread}`);
        if (activeId.includes(item.entry.id)) {
            event.dataTransfer.setData('text', activeId);
        }
        else {
            event.dataTransfer.setData('text', item.entry.id);
        }
    }, [activeId]);
    const handleMailDragStart = useCallback((event, item, index) => {
        defaultOnMailDrag(event, item);
        onDragStart && onDragStart(event, item, index);
    }, [onDragStart, defaultOnMailDrag]);
    const topMailGroupDecorate = useMemo(() => {
        return (data, preIndex) => {
            if (data && data.length) {
                let topSum = 0;
                let hasTop = false;
                for (let i = preIndex; i < data.length; i++) {
                    if (data[i].entry.top) {
                        topSum += 1;
                        hasTop = true;
                    }
                    else {
                        break;
                    }
                }
                if (hasTop) {
                    return [
                        {
                            key: 'top',
                            content: getIn18Text('ZHIDING') + '  ' + topSum + '封',
                            isFoldable: true,
                            index: preIndex,
                            height: 36,
                            position: 'top',
                            isCheckable: true,
                            fixed: {
                                height: 27 + 5,
                            },
                        },
                        {
                            key: 'top-null',
                            element: React.createElement(React.Fragment, null),
                            index: preIndex + topSum - 1,
                            height: 0,
                            position: 'bottom',
                            ignore: true,
                        },
                    ];
                }
            }
            return null;
        };
    }, []);
    const mailSenderGroupDecorate = useMemo(() => {
        return (data, preIndex) => {
            try {
                if (data && data.length) {
                    const decorateList = [];
                    let start = renderContacts(data[preIndex]);
                    let startIndex = preIndex;
                    for (let i = preIndex + 1; i < data.length; i++) {
                        if (renderContacts(data[i]) != start || i == data.length - 1) {
                            decorateList.push({
                                key: start,
                                content: `${start} (${i - startIndex})封`,
                                index: startIndex,
                                height: 27 + 9,
                                position: 'top',
                                isFoldable: true,
                                isCheckable: true,
                                fixed: {
                                    height: 27 + 5,
                                },
                            });
                            start = renderContacts(data[i]);
                            startIndex = i;
                        }
                    }
                    if (startIndex == data.length - 1 && start != renderContacts(data[data.length - 1])) {
                        decorateList.push({
                            key: start,
                            content: `${start} (${1})封`,
                            index: startIndex,
                            isFoldable: true,
                            isCheckable: true,
                            height: 27 + 9,
                            position: 'top',
                            fixed: {
                                height: 27 + 5,
                            },
                        });
                    }
                    return decorateList;
                }
            }
            catch (e) {
                console.error('[mailSenderGroupDecorate Error]', e);
                return null;
            }
            return null;
        };
    }, []);
    const mailGroupDecorate = useMemo(() => {
        const isTaskFlolder = (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) === FLOLDER.TASK;
        let list = [];
        const isVirtualFolder = Number.isInteger(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) ? (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) < 0 : false;
        if (selected == 'ALL' && !folderIdIsContact(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) && !isVirtualFolder && !folderIdIsAllFolder(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id)) {
            list.push(topMailGroupDecorate);
        }
        if (isMainAccount(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId)) {
            if (['ORDER_BY_SENDER_CAPITAL_DESC', 'ORDER_BY_SENDER_CAPITAL_ASC', 'ORDER_BY_RECEIVER_CAPITAL_DESC', 'ORDER_BY_RECEIVER_CAPITAL_ASC'].includes(selected)) {
                list.push(mailSenderGroupDecorate);
            }
        }
        if (!isTaskFlolder &&
            (selected == 'ALL' || selected == 'REDFLAG' || selected == 'UNREAD' || selected == 'COLLEAGUE' || selected == 'ME' || selected == 'SEND' || selected == 'RECEIVE')) {
            list.push((data, fromIndex = 0) => {
                const timeHashes = scanMailsSetTimeGradients(data, fromIndex, checkable);
                return timeHashes;
            });
        }
        return list;
    }, [selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId, selected, checkable]);
    const listRef = useRef();
    useEffect(() => {
        var _a;
        if (scrollTop == 0 && scrollTop != scrollTopRef.current) {
            (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToPosition(scrollTop);
            scrollTopRef.current = scrollTop;
        }
    }, [scrollTop]);
    const getCardItemHeight = (data) => {
        return getCardHeight(data, forceShowAttachment, showSuborbinateFrom);
    };
    useMailListHotkeys({
        data,
        activeId,
        onActiveInWindow,
        hkDisabled,
        onDelete,
    });
    const ListElement = useMemo(() => {
        return (React.createElement(ListHotKeys, { onSelect: onSelect, onUnSelect: onUnSelect, onActive: onActive, beforeSelected: beforeSelected, hkDisabled: hkDisabled, ref: listRef, className: `${systemIsWindow() ? 'u-vlist-win' : 'u-vlist'}`, containerStyle: {
                marginTop: selectedKeys && (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) === FLOLDER.DEFAULT && notice ? 0 : '12px',
            }, style: inWindow() && !locationHelper.isMainPage()
                ? {
                    overflowX: 'hidden',
                    height: '95vh',
                }
                : {
                    overflowX: 'hidden',
                }, height: listHeight, card: CustomMailCard, rowHeight: getCardItemHeight, width: listWidth, onLoadMore: start => loadMoreRows({ startIndex: start }), scrollTop: scrollTop, batchSize: 100, threshold: 500, cardMargin: 1, useRealList: useRealList, realListPager: realListPager, realListClassName: realListClassName, data: data, total: rowCount, getUniqKey: getMailKey, onPullRefresh: refreshPage, activeId: activeId, isRefresh: isRefresh, onDoubleClick: (keys, data, index, event) => {
                onDoubleClick && onDoubleClick(data, index, event);
            }, onContextMenu: (keys, data, index, event) => {
                onContextMenu && onContextMenu(keys, data, index, event);
            }, draggable: listCanDrag() && mailCanDrag, onDragStart: (e, data, index) => {
                handleMailDragStart(e, data, index);
            }, onDragEnd: onDragEnd, onScroll: arg => {
                scrollTopRef.current = arg === null || arg === void 0 ? void 0 : arg.scrollTop;
                onScroll && onScroll(arg);
            }, cardGroupDecorate: showGroupDecorate ? mailGroupDecorate : null, topExtraData: isMainAccount(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId) ? topExtraData : null, selectModel: listModel, onListModelChange: (model, activeIds) => {
                if ((selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) == FLOLDER.TASK) {
                    if (model === LIST_MODEL.INIT) {
                        onListModelChange && onListModelChange(model);
                    }
                }
                else {
                    if (model === LIST_MODEL.INIT) {
                        onListModelChange && onListModelChange(model);
                    }
                    else if (activeIds && (activeIds === null || activeIds === void 0 ? void 0 : activeIds.length) > 0) {
                        onListModelChange && onListModelChange(model);
                    }
                }
            }, isMultiple: listModel == LIST_MODEL.MULTIPLE, scrollingResetTimeInterval: scrollingResetTimeInterval, overscanRowCount: overscanRowCount, pullRefreshLoadingHeight: pullRefreshLoadingHeight, loadMoreLoadingHeight: loadMoreLoadingHeight, noMoreRender: noMoreRender, pullRefreshRender: pullRefreshRender, loadMoreLoadingRender: loadMoreLoadingRender, noRowsRenderer: noRowsRenderer, loadMoreLoadingFailRender: loadMoreLoadingFailRender, listFouceRender: listFouceRender, onContentInsufficientHeight: onContentInsufficientHeight, onGroupCollapse: onGroupCollapse, groupCollapse: groupCollapse }));
    }, [
        notice,
        onSelect,
        onUnSelect,
        onActive,
        beforeSelected,
        hkDisabled,
        data,
        selectedKeys,
        listHeight,
        listWidth,
        CustomMailCard,
        getCardHeight,
        loadMoreRows,
        rowCount,
        getMailKey,
        refreshPage,
        activeId,
        onDoubleClick,
        onContextMenu,
        listCanDrag,
        mailCanDrag,
        handleMailDragStart,
        showGroupDecorate,
        mailGroupDecorate,
        topExtraData,
        listModel,
        onDragEnd,
        total,
        batchSize,
        threshold,
        scrollingResetTimeInterval,
        overscanRowCount,
        pullRefreshLoadingHeight,
        loadMoreLoadingHeight,
        onScroll,
        noMoreRender,
        pullRefreshRender,
        loadMoreLoadingRender,
        noRowsRenderer,
        onPullRefresh,
        onLoadMore,
        loadMoreLoadingFailRender,
        listFouceRender,
        useRealList,
        onListModelChange,
        isRefresh,
        onContentInsufficientHeight,
        onGroupCollapse,
        groupCollapse,
    ]);
    const currentPageSize = useAppSelector(state => state.mailReducer.realListCurrentPageSize);
    useImperativeHandle(ref, () => listRef.current, []);
    return (React.createElement("div", { className: 'mail-list' + (!useRealList ? ' sirius-no-drag' : '') },
        ListElement,
        useMemo(() => {
            return listLoading && React.createElement(ListLoading, { loading: listLoading, isUseRealList: useRealList, pageSize: currentPageSize });
        }, [listLoading, currentPageSize, useRealList])));
};
export default React.forwardRef(MailList);
